import { render, staticRenderFns } from "./ContactInfoFields.vue?vue&type=template&id=72ef3300"
import script from "./ContactInfoFields.vue?vue&type=script&lang=js"
export * from "./ContactInfoFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmFieldEmail: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldEmail.vue').default})
